module.exports = __webpack_public_path__ + "img/tab04.ea4f1e0b.jpg";